import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/member/findUnusualPage', data, {
    trim: true
  })
}

// 人员移除-解冻
export function updateRemoveStatusById (data) {
  return request.post('/business/member/updateRemoveStatusById', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/member/exportExcel', data, {
    trim: true,
    download: true
  })
}
